module.exports = __webpack_public_path__ + "img/logo-v.9a66ab4b.png";